import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from '../config/app-config';
import { AppConfigService } from '../config/app-config.service';

@Injectable({
  providedIn: 'root',
})
export class SkiftBrugerService {
  appConfig: AppConfig;
  constructor(private appConfigService: AppConfigService, private http: HttpClient) {}

  intialize() {
    this.appConfig = this.appConfigService.getConfig();
  }

  setCookie(cookieName: string, value: string) {
    const url = this.appConfig.dokumentWebUrl + `/skiftbruger/setcookie`;
    const options = {
      headers: new HttpHeaders().set(cookieName, value),
    };
    return this.http.get(url, options);
  }

  removeCookie() {
    const url = this.appConfig.dokumentWebUrl + `/skiftbruger/removecookie`;
    return this.http.get(url);
  }
}
